module.exports = __webpack_public_path__ + "static/media/out-left-front.bded197f.png";